module.exports = __webpack_public_path__ + "static/valworx-f5cbd5bf7cf194d7efc75e95f0df0c51.png";